import { useContext } from 'react';

import { Context } from '@/context';

import ShareArticle from './share-article';
import { Box, Typography } from '@mui/material';

const ShareArticleAdminComponent = ({ ruta, title, icon, hashtags = [] }) => {
    const { state } = useContext(Context);
    const { user } = state;

    if (user?.isAdmin) {
        return (
            <Box display="flex" justifyContent="flex-end">
                <Typography variant="body2" mr={1}>
                    Compartir en:
                </Typography>
                <ShareArticle
                    articleUrl={`https://www.analiticafantasy.com${ruta}`}
                    title={`${icon ?? 'ℹ️'}  ${title}. \n \n`}
                    hashtags={hashtags}
                />
            </Box>
        );
    } else {
        return null;
    }
};

export default ShareArticleAdminComponent;
